import React, { memo } from "react";

function CommImg() {
    return (
        <svg width="32" height="16" viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="16" rx="4" fill="url(#paint0_linear_2928_12251)" />
            <path
                d="M4.215 12V4.3H5.997L8.813 8.667C8.82767 8.689 8.87533 8.76967 8.956 8.909C9.03667 9.041 9.099 9.162 9.143 9.272V4.3H10.881V12H9.099L6.283 7.6C6.26833 7.578 6.22067 7.49733 6.14 7.358C6.04467 7.19667 5.98233 7.07567 5.953 6.995V12H4.215ZM12.0146 12V4.3H17.6356V5.862H13.7966V7.259H17.3276V8.777H13.7966V10.438H17.6686V12H12.0146ZM20.0736 12L17.9616 4.3H19.8426L20.8766 8.59C20.9059 8.73667 20.9316 8.84667 20.9536 8.92C20.9682 8.986 20.9866 9.08133 21.0086 9.206C21.0379 9.33067 21.0562 9.415 21.0636 9.459L21.2396 8.579L22.3176 4.3H24.1656L25.2436 8.579L25.4196 9.459C25.4269 9.415 25.4416 9.33067 25.4636 9.206C25.4929 9.08133 25.5149 8.986 25.5296 8.92C25.5516 8.84667 25.5772 8.73667 25.6066 8.59L26.6406 4.3H28.5216L26.4096 12H24.5286L23.2416 6.973L21.9546 12H20.0736Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2928_12251"
                    x1="32"
                    y1="16"
                    x2="0"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#C66207" />
                    <stop offset="1" stopColor="#FFA318" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default memo(CommImg);
